import { combineReducers, configureStore } from '@reduxjs/toolkit'
import orderReducers from '../features/order/orderSlice'
import authReducers from '../features/auth/authSlice'
import settingReducers from '../features/setting/settingSlice'
import userReducers from '../features/user/userSlice'
import profileReducers from '../features/profile/profileSlice'
// Persist
import thunk from 'redux-thunk'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'

const rootReducer = combineReducers({
  auth: authReducers,
  order: orderReducers,
  setting: settingReducers,
  user: userReducers,
  profile: profileReducers,
})

const persistConfig = {
  key: 'exlusive-admin',
  version: 1,
  storage,
  whitelist: ['auth'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
})

export const persistor = persistStore(store)
